import { View } from 'backbone.marionette';
import template from './index.jst';
import mobile_denied_tpl from './mobile_denied.jst';
import end_season_tpl from './end_season.jst';
import './index.styl';

export class TradesView extends View {
	get template() {
		return this._template;
	}

	set template(tpl) {
		this._template = tpl;
	}

	get className() {
		return 'team-trades shadow';
	}

	constructor(...args){
		super(...args);
		this._template = template;
	}

	setMobileDeniedTemplate(){
		this.template = mobile_denied_tpl;
	}
	setEndSeason() {
		this.template = end_season_tpl;
	}
	setPreSeason() {
		this.template = template
	}
}

export default TradesView;